<template>
  <div>
    <div class="table-section-header-select-group">
      <div v-if="sortProperty" v-on:click="onSortDirectionClick(sort.direction)" class="sort pr-1">
        <Icon
          :size="14"
          class="rotating"
          :rotate="getSortIconRotation()"
          icon="sort-arrow"
          color="epsilon"
        />
      </div>
      <div class="d-flex align-items-center">
        <label :for="id" class="pr-3">{{ $t("global.sort-by") }}</label>
        <div>
          <select :id="id" :value="sortProperty" v-on:change="onSortSelect" class="form-control">
            <option :value="null">
              - - -
            </option>
            <option
              v-for="(option, index) in sortableHeaders"
              v-bind:key="index"
              v-bind:value="option.sortProperty"
            >
              {{ option.display.value }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import Icon from "@/components/display/icon/Icon";
import { uniqueId } from "lodash-es";

export default {
  name: "TableSort",
  props: {
    name: String,
    headers: Array,
    sort: Object,
  },
  components: {
    Icon,
  },
  setup(props, { emit }) {
    const id = uniqueId(
      props.name ? `${props.name?.toLowerCase()}-sort-by-input-` : "sort-by-input-"
    );
    const updateSort = (sort) => {
      emit("update:sort", sort);
    };
    const updateSelected = (value) => {
      emit("update:selected", value);
    };
    const sortableHeaders = computed(() => props.headers.filter((header) => header.sortProperty));
    const sortProperty = computed(() => props.sort?.property);
    const onSortSelect = (e) => {
      const property = e.target.value;
      const sort = property ? { property, direction: "asc" } : null;
      updateSort(sort);
      const getSelected = (property) => {
        if (!property) return null;
        const header = props.headers.find((header) => header.sortProperty === property);
        return header.display.value;
      };
      updateSelected(getSelected(property));
    };
    const onSortDirectionClick = (direction) => {
      updateSort({
        property: props.sort.property,
        direction: direction === "asc" ? "desc" : "asc",
      });
    };
    const getSortIconRotation = () => (props.sort.direction === "desc" ? 180 : 0);

    return {
      id,
      sortableHeaders,
      sortProperty,
      onSortSelect,
      onSortDirectionClick,
      getSortIconRotation,
    };
  },
};
</script>

<style lang="scss" scoped>
.table-section-header-select-group {
  display: flex;
  font-size: 0.75rem;
  align-items: center;
  justify-content: flex-end;
  label {
    display: inherit;
    margin-bottom: 0;
  }
  input {
    width: 4.5rem;
  }
}
.sort {
  cursor: pointer;
  &:hover {
    opacity: 0.5;
  }
}
</style>
